import { Box } from "@mui/system";
import { useRef } from "react";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";
import { useEntityInputFormInfo } from "@/common/hooks/entity/useEntityInputFormInfo";

import AppModalContent from "../../Modals/AppModalContent";
import {
  BaseEntityCreateUpdateModal,
  BaseEntityCreateUpdateModalInheritableProps,
} from "../components/BaseEntityCreateUpdateModal";
import RepairMaterialCreateUpdate, {
  RepairMaterialCreateUpdateHandle,
  RepairMaterialCreateUpdateProps,
} from "./RepairMaterialCreateUpdate";

interface Props extends BaseEntityCreateUpdateModalInheritableProps {
  createUpdateProps: RepairMaterialCreateUpdateProps;
}

export default function RepairMaterialCreateUpdateModal({
  createUpdateProps,
  ...modalProps
}: Props) {
  const formInfo = useEntityInputFormInfo({ entityId: createUpdateProps.repairMaterialId });
  const formWrapperRef = useRef<RepairMaterialCreateUpdateHandle | null>(null);

  return (
    <BaseEntityCreateUpdateModal
      fullWidth
      maxWidth='lg'
      {...modalProps}
      formWrapperRef={formWrapperRef}
    >
      {(params) => (
        <>
          <AppModalTitle onClose={params.close}>
            {formInfo.isCreate ? "Create new" : "Edit"} repair material
          </AppModalTitle>
          <AppModalContent>
            <Box sx={{ py: 1 }}>
              <RepairMaterialCreateUpdate ref={formWrapperRef} {...createUpdateProps} />
            </Box>
          </AppModalContent>
        </>
      )}
    </BaseEntityCreateUpdateModal>
  );
}
